import analytics from "./analytics";
import ask from "./ask";
import auth from "./auth/index";
import categoryDocuments from "./categoryDocuments";
import company from "./company/index";
import connections from "./connections/index";
import { currencyList } from "./currency";
import currentPermissions from "./currentPermissions";
import customers from "./customers/index";
import dashboard from "./dashboard";
import detailsDocument from "./detailsDocument/index.jsx";
import documents from "./documents/index.jsx";
import documentsWithSearch from "./documentsWithSearch/index.jsx";
import documentPreview from "./documentPreview";
import download from "./download/index";
import deadlinesAccountant from "./deadlinesAccountant";
import deadlinesCompany from "./deadlinesCompany";
import deadlinesDetail from "./deadlinesDetail";
import fulfilments from "./fulfilments/index.js";
import folders from "./folders";
import foldersDetail from "./foldersDetail";
import notify from "./deadlines/table/tableBody.js";
import recipient from "./recipient";
import servicesAgyo from "./services/index.js";
import signature from "./signature/index";
import sso from "./sso/sso-auth";
import statistics from "./statistics";
import studio from "./studio";
import tspay from "./tspay";
import reconciliation from "./reconciliation";
import notes from "./notes";
import ncs from "./ncs";
import incassaSubito from "./incassaSubito";
import tags from "./tags/tags";
import user from "./users/index";
import usersList from "./usersList";
import main from "./main";
import parties from "./parties";
import precog from "./precog";
import intrastatDrawer from "./precog/intrastatDrawer";
import chartAccounts from "./chartAccounts";
import reports from "./reports";
import taxCredit from "./taxCredit";
import rating from "./rating";
import featureFlags from "./features";
import { overflow } from "./timed-notifications";
import { combineReducers } from "redux";

const timedNotifications = combineReducers({
  overflow
});

const reducersSchema = {
  analytics,
  ask,
  auth,
  categoryDocuments,
  company,
  connections,  
  currencyList,
  currentPermissions,
  customers,
  deadlinesAccountant,
  detailsDocument,
  deadlinesCompany,
  deadlinesDetail,
  dashboard,
  documents,
  documentsWithSearch,
  documentPreview,
  download,
  folders,
  foldersDetail,
  fulfilments,
  incassaSubito,
  ncs,
  notes,
  notify,
  recipient,
  servicesAgyo,
  signature,
  sso,
  statistics,
  studio,
  tags,
  timedNotifications,
  tspay,
  reconciliation,
  user,
  usersList,
  main,
  parties,
  precog,
  reports,
  taxCredit,
  chartAccounts,
  rating,
  featureFlags,
  intrastatDrawer
};

export default reducersSchema;
